<template>
  <div>
    <div class="modal fade show custom-modal" id="topUpPackage" role="dialog" :class="{'modal-show':showModal}">
      <div class="modal-dialog modal-dialog-centered modal-lg" v-if="odPlanList[cardPosition] && odPlanList[cardPosition].topUpPackages">
        <div class="modal-content" :class="{'freeze-loader' : verifyLoaderEnabledTopUp}">
          <div class="modal-header">
            <h5 class="modal-title ml-4 float-left font-weight-bold">Top Up Packages</h5>
            <button type="button" class="close" id="top-up-cross-close" @click="addTopUpPackage()" :disabled="state.isAddBtnDisabledOnPackageDetailsCall">&times;</button>
          </div>
          <div class="ml-3 mr-4">
            <div class="style-border mt-1"></div>
          </div>
          <div class="modal-body mt-1 pb-0">
            <div class="col-lg-12 col-md-12 col-sm-12 mr-0">
              <div class="row mt-3 mb-1 p-0">
                <div class="col-lg-6 col-md-12 col-sm-12 pt-3" v-for="(type, index) in odPlanList[cardPosition].topUpPackages" :key="index">
                  <div class="py-3 package-cover-height" :class="{'package-cover-grey': setCoverClass(index),'package-cover-dynamic-height':type.extraFields && Object.keys(type.extraFields).length>0}" >
                    <input
                      type="checkbox"
                      class="bgc-checkbox checkbox-position position-relative"
                      :id="'topupcheck'+' '+index"
                      v-model="type.value"
                      @change="toggleCheckbox()+callGetPackageDetails(type.value,type.packageCode,odPlanList[cardPosition],type,cardPosition)"
                    >
                    <label class="form-check-label" :for="'topupcheck'+' '+index">
                      <span class="pl-3" > {{type.packageName }}</span>
                    </label>
                    <span class="loader small inline" v-if="type.premiumLoader"
                      ><img
                        src="@/assets/images/loader.gif"
                        alt="Premium Loader"
                        class="premium-loader" />
                    </span>
                    <div class="pl-3 py-3 my-3 card shadow topupdiscount-card" v-if="type.value && type.hasOwnProperty('covers') && checkFurtherDiscountAvailableTopUp(type.covers)">
                      <p class="topup-discount-header font-weight-bold">Apply Cover Discount</p>
                      <div class="d-flex py-2" v-for="(obj, k) in type.covers.coverDetails" :key="k">
                        <span class="additional-input-discount">{{obj.coverName}} (Max Value: {{obj.coverParamMap['Further Discount Max Value']}})</span>
                        <input 
                          type="text" 
                          class="style-box"
                          :class="{'input-field-error': parseInt(obj.coverParamMap['Further Discount Percentage']) > parseInt(obj.coverParamMap['Further Discount Max Value'])}"
                          :maxlength="2"
                          v-on:keydown="onlyNumber"
                          v-model="obj.coverParamMap['Further Discount Percentage']">
                      </div>
                    </div>
                    <div class="pl-3 py-3 card shadow my-3" v-if="type.value && type.extraFields && Object.keys(type.extraFields).length>0">
                      <p class="topup-discount-header font-weight-bold">Additional Fields</p>
                      <div class="pt-2" v-for="(param,i) in Object.keys(type.extraFields)" :key='i'>
                        <span class="mr-4"><label :for="param" class="font-weight-bold label-font-size">{{param}}</label></span>
                        <br/>
                        <select v-if='type.domainList[param]'
                          class="additional-input"
                          :id="param"
                          v-model="type.extraFields[param]"
                          :placeholder="param"
                        >
                          <option disabled value='null'>{{param}}</option>
                          <option v-for="(domain) in type.domainList[param]" :key="domain.code?domain.code:domain.name" :value='domain.code?domain.code:domain.name'>{{domain.name}}</option>
                        </select>
                        <input class="additional-input"
                          type="text"
                          v-on:keydown="onlyNumber"
                          v-else
                          :id="param"
                          v-model="type.extraFields[param]"
                          :placeholder="param"
                        /> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ml-3 mr-4">
            <div class="style-border mt-1"></div>
          </div>
          <div>
            <div class="modal-footer border-0 float-right mr-2">
              <button 
                type="button" 
                class="btn bgc-btn-primary button-add" 
                data-dismiss="modal" 
                id="top-up-package-add"
                @click="addTopUpPackage()"
                :disabled="!state.isAddBtnEnabled || disableForExtraFields || state.isAddBtnDisabledOnPackageDetailsCall"
                >Add</button>
            </div>
            <div class="validate-max-val text-danger ml-2 pl-2 my-2" v-if="state.isCoverDiscountExceeded">Applied Cover Discount value is greater than the Max value!</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import functions from "@/../../masters/functions.js";
import { reactive,onUpdated, computed } from "@vue/composition-api";
export default {
  name: 'TopUpPackageModal',
  props:["odPlanList", "cardPosition", "showModal","windowWidth","initialTopUpPackages"],
  setup(props,context){
    let state=reactive({
      isAddBtnEnabled : false,
      isCoverDiscountExceeded: false,
      isAddBtnDisabledOnPackageDetailsCall : false,
      extraFieldName:''
    });
    const onlyNumber = functions.onlyNumber;
    function closeTopUpPackageModal(){
      context.parent.closeTopUpPackageModal();
      state.isAddBtnEnabled = false;
    }
    function addTopUpPackage(){
      let isError = false;
      for(let j=0; j<props.odPlanList[props.cardPosition].topUpPackages.length; j++){
        if(props.odPlanList[props.cardPosition].topUpPackages[j].value && props.odPlanList[props.cardPosition].topUpPackages[j].covers && Array.isArray(props.odPlanList[props.cardPosition].topUpPackages[j].covers.coverDetails)){
          for(let k=0; k<props.odPlanList[props.cardPosition].topUpPackages[j].covers.coverDetails.length;k++){
            if(props.odPlanList[props.cardPosition].topUpPackages[j].covers.coverDetails[k].coverParamMap['Further Discount Percentage'] && 
            parseInt(props.odPlanList[props.cardPosition].topUpPackages[j].covers.coverDetails[k].coverParamMap['Further Discount Percentage']) > parseInt(props.odPlanList[props.cardPosition].topUpPackages[j].covers.coverDetails[k].coverParamMap['Further Discount Max Value'])){
              isError = true;
              break;
            }
          }
        }
      }
      if(isError){
        state.isCoverDiscountExceeded = true;
      }else{
        state.isCoverDiscountExceeded = false;
        context.parent.addTopUpPackage(props.cardPosition);
        closeTopUpPackageModal();
      }
    }
    function setCoverClass(index){
      let flag = false;
      if(props.windowWidth.value && props.windowWidth.value>=992){
        for(let i=0;i<=index;i++){
          if(4*i+2==index || index==4*i+3){
            flag = true;
          }
        }
      }
      else{
        if(index%2 !=0){
          flag = true;
        }
      }
      return flag;
    }
    function showExtaField(obj){
      let flag= false;
      if(obj.hasOwnProperty('extraFields')){
        flag=true;
      }
      return flag;
    }
    function isExtraFieldOD(param){
      state.extraFieldName=param ? param:'';
      if(param == "") return false;
      let keyArray = ["Cover Level Transaction Currency for Sum Insured","Cover Max Age","Discount Percentage","Further Discount Applicable","Further Discount Percentage","Loading Percentage",
      "Further Discount Max Value"];
      if(!keyArray.includes(param) && !param.includes("DomainList") && !param.includes("Tyre")) return true;
      return false;
    }
    function toggleCheckbox(){
      let verifyFlag = false;
      for(let i=0; i<props.odPlanList[props.cardPosition].topUpPackages.length; i++){
        if(props.initialTopUpPackages[i]!==props.odPlanList[props.cardPosition].topUpPackages[i].value){
          verifyFlag = true;
          break;
        }
      }
      if(verifyFlag)
        state.isAddBtnEnabled = true;
      else
        state.isAddBtnEnabled = false;
    }
    const disableForExtraFields = computed(()=>{
      let verifyFlag = false;
      if(props.odPlanList[props.cardPosition] && props.odPlanList[props.cardPosition].hasOwnProperty('topUpPackages') && Array.isArray(props.odPlanList[props.cardPosition].topUpPackages)){
        for(let i=0; i<props.odPlanList[props.cardPosition].topUpPackages.length; i++){
          if(props.odPlanList[props.cardPosition].topUpPackages[i].value){
            if(props.odPlanList[props.cardPosition].topUpPackages[i].extraFields && Object.keys(props.odPlanList[props.cardPosition].topUpPackages[i].extraFields).length>0){
              let obj= props.odPlanList[props.cardPosition].topUpPackages[i].extraFields;
              Object.keys(obj).forEach(ele=>{
                if(!obj[ele]){
                  verifyFlag= true;
                }
              })
            }
          }
        }
      }
      if(verifyFlag)
        return true;
      return false;
    })
    const verifyLoaderEnabledTopUp = computed(()=>{
      let freezeFlag = false;
      if(props.odPlanList[props.cardPosition] && props.odPlanList[props.cardPosition].hasOwnProperty('topUpPackages') && Array.isArray(props.odPlanList[props.cardPosition].topUpPackages)){
        props.odPlanList[props.cardPosition].topUpPackages.forEach(obj=>{
          if(obj.premiumLoader){
            freezeFlag = true;
            return freezeFlag;
          }
        })
        return freezeFlag;
      }
      return freezeFlag
    })
    function checkFurtherDiscountAvailableTopUp(coverObj){
      if(coverObj && Array.isArray(coverObj.coverDetails) && coverObj.coverDetails.length > 0){
        let tempDiscountArr = coverObj.coverDetails.filter(obj=> { return obj.coverParamMap['Further Discount Applicable'] === 'Y'});
        if(tempDiscountArr.length > 0)
          return true;
        return false;
      }
      return false;
    }
    function callGetPackageDetails(value,packageId,plan,type,cardPosition){
      if(value){
        state.isAddBtnDisabledOnPackageDetailsCall = true;
        context.root.$set(type,"premiumLoader",true);
        setTimeout(() => {
          context.root.$set(type,"premiumLoader",false);
          state.isAddBtnDisabledOnPackageDetailsCall = false;
        }, 2800);
        context.parent.callPackageDetailsOD(undefined, undefined, cardPosition, packageId,'topup',plan);
      }
      else{
        type.extraFields={};
        type.domainList={};
      }
    }
    onUpdated(()=> {
      window.addEventListener('resize',()=>{
        props.windowWidth.value = window.screen.width
      })
    });
    return{
      state,
      closeTopUpPackageModal,
      addTopUpPackage,
      onlyNumber,
      callGetPackageDetails,
      checkFurtherDiscountAvailableTopUp,
      verifyLoaderEnabledTopUp,
      showExtaField,
      setCoverClass,
      isExtraFieldOD,
      toggleCheckbox,
      disableForExtraFields
    }
  }
};
</script>
<style scoped>
.package-cover-grey{
  background-color: rgba(30, 30, 30, 0.1);
}
.package-cover-dynamic-height{
  height: auto;
}
.label-font-size{
  font-size: 13px;
}
.top-up-discount-text{
  font-size: 10px;
}
.topupdiscount-card{
  background-color: transparent;
}
.input-field-error{
  border: 1px solid red;
}
.freeze-loader{
  pointer-events: none;
}
.topup-discount-header{
  font-size: 13px;
  text-decoration: underline;
}
input[type="text"].style-box {
  line-height: 6px;
  min-height: 33px;
  max-width: 20%;
  float: right;
}
.additional-input{
  width: 90%;
  line-height: 33px;
  height: 33px;
  min-height: 33px;
  color: #666666;
  font-size: 12px;
  border-radius: 5%;
}
.additional-input-discount{
  width: 90%;
  line-height: 20px;
  height: 33px;
  min-height: 33px;
  color: #666666;
  font-size: 13px;
  border-radius: 5%;
}
button.close {
  padding-top: 13px;
  text-align: right;
}
.button-add {
  width: 130px;
}
.checkbox-position {
  left: 15px;
}
.style-border {
  border-bottom: 1px solid #c7c7c7;
}
.bg-color {
  background-color: rgb(0, 0, 0, 0.05);
}
.imt-cover-grey{
  background-color: rgba(30, 30, 30, 0.1);
}
/* .select-all {
  left: calc(100% - 289px);
} */
</style>